// Code review - In Progress
// Documentation - In Progress
import React from "react";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import TextArea from "../ReusableComponents/TextArea";
import TextEditor from "../ReusableComponents/TextEditor";

const QuestionsPopup = ({ data, data1 }) => {
  return (
    <div class="w-full">
      <div class={mainTable.mainContentScreen}>
        <form class="overflow-auto p-5 lg:h-96 md:min-h-[60vh] md:max-h-[60vh] min-h-fit max-h-fit sm:min-h-fit  sm:max-h-fit">
          <div class="grid gap-4 mb-2 md:grid-cols-4">
            <AutoDropDown
              title="Module"
              options={[]}
              placeholder="Select"
              name="module"
              selectedOption={[data1[0]]}
              Class="custom-class"
              tabIndex="1"
              disabled={true}
              classStar="text-red-500"
            />

            <div class="sm:col-span-2">
              <AutoDropDown
                title="Topic"
                options={[]}
                placeholder="Select"
                name="topic"
                selectedOption={[data1[1]]}
                Class="custom-class"
                tabIndex="1"
                disabled={true}
                classStar="text-red-500"
              />
            </div>
            <InputText
              inputType={"text"}
              title="Topic No."
              name={"topicNo"}
              classStar={"text-red-500"}
              maxLength={100}
              disabled={true}
              content={data.TopicNumber}
            />
          </div>
          <div className="">
            <div
              className="mb-4 border border-gray-300 p-4 rounded relative"
            >
              {/* Additional Fields */}
              <div className={mainTable.grid2}>
                <InputText
                  inputType={"text"}
                  title={"Question No."}
                  name={"questionsNo"}
                  classStar={"text-red-500"}
                  maxLength={100}
                  disabled={true}
                  content={data.QuestionNumber}
                />

                <InputText
                  inputType={"text"}
                  title={"Version"}
                  name={"version"}
                  classStar={"text-red-500"}
                  maxLength={100}
                  disabled={true}
                  content={data.Version}
                />
              </div>

              <div className="mt-4">
                <TextArea
                  title={`Question`}
                  name={`answer`}
                  disabled={true}
                  content={data.Question}
                />
              </div>

              <div className="mt-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Guidance<span className={"text-red-500"}>*</span>
                </label>
                <TextEditor value={data.Guidance}
                  disabled={true} />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default QuestionsPopup;
